import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-price-list-montage',
  templateUrl: './price-list-montage.component.html',
  styleUrls: ['./price-list-montage.component.css']
})
export class PriceListMontageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
